import React, { memo, useImperativeHandle, forwardRef } from 'react'
import MuiSwitch from '@material-ui/core/Switch'
import PropTypes from 'prop-types'

import { useBaseComponentOperations } from '../../hooks'
import FormControlLabel from './FormControlLabel'
import { eventObject, defaultColor } from './common'

/**
 * Implements Mui Switch.
 *
 * @param {object} props component props
 * @returns {Switch} Switch component
 */
const Switch = memo(forwardRef((props, ref) => {
  const { noTranslate, ...finalProps } = props 
  const eventKey = 'checked'
  const [value, onChange] = useBaseComponentOperations(props, eventKey, props.defaultValue !== undefined ? props.defaultValue : false)
  useImperativeHandle(ref, () => ({
    getValue: () => value,
    setValue: value => {
      onChange(eventObject(eventKey, value))
    }
  }))
  return (
    <>
      { props.label
        ? <FormControlLabel
            control={
              <MuiSwitch
                {...finalProps}
                checked={value}
                onChange={onChange}
                color={finalProps.color || defaultColor}
              />
            }
            label={finalProps.label}
          />
        : <MuiSwitch
            {...finalProps}
            checked={value}
            onChange={onChange}
            color={finalProps.color || defaultColor}
          />
      }
    </>
  )
}))

Switch.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  /**
   Default value for the control.
   */ 
  defaultValue: PropTypes.bool,
  /**
   Label to display for the control.
   */ 
  label: PropTypes.string,
  /**
   onChange function called when the checkbox is clicked.
   */
  onChange: PropTypes.func,
  /**
   MUI color for the checkbox.
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'default']),
  /**
   Determines if the control is disabled.
   */
  disabled: PropTypes.bool,
  /**
   Prevents the language translation of the label.
   */
  noTranslate: PropTypes.bool,
}

Switch.defaultProps = {
  color: defaultColor
}

export default Switch